import React from 'react';
import { Button } from '../ui/Button';
import { CalendarIcon, CheckCircleIcon, CarIcon } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <CalendarIcon className="h-12 w-12" data-id="element-160" />,
    title: 'Schedule Your Ride',
    description: 'Call or book online with pickup, destination, and mobility needs.'
  }, {
    icon: <CheckCircleIcon className="h-12 w-12" data-id="element-161" />,
    title: 'Confirm Details',
    description: 'We assign the right vehicle and driver for your specific needs.'
  }, {
    icon: <CarIcon className="h-12 w-12" data-id="element-162" />,
    title: 'On-Time Pickup & Safe Arrival',
    description: 'Our trained driver assists you safely to your destination.'
  }];
  return <section className="bg-[#F5F5F5] py-20" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4" data-id="element-164">
        <div className="text-center mb-12" data-id="element-165">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0B1F3A] mb-6" data-id="element-166">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-167">
            Getting reliable medical transportation is easy with our simple
            3-step process
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 relative" data-id="element-168">
          {steps.map((step, index) => <div key={index} className="relative" data-id="element-169">
              <div className="bg-white rounded-lg shadow-md p-8 text-center h-full" data-id="element-170">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-[#E63946] bg-opacity-10 rounded-full mb-6 text-[#E63946]" data-id="element-171">
                  {step.icon}
                </div>
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-10 h-10 bg-[#E63946] text-white rounded-full flex items-center justify-center font-bold text-lg" data-id="element-172">
                  {index + 1}
                </div>
                <h3 className="text-xl font-bold text-[#0B1F3A] mb-4" data-id="element-173">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-174">{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gray-300" data-id="element-175"></div>}
            </div>)}
        </div>

        <div className="text-center" data-id="element-176">
          <Button variant="primary" size="lg" onClick={() => document.getElementById('hero')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-177">
            Book Your Ride Now
          </Button>
        </div>
      </div>
    </section>;
}